import { createRouter, createWebHistory } from '@ionic/vue-router';

const routes = [
  {
    path: '/',
    component: () => import('../pages/MainPage.vue')
  },
  {
    path: '/login',
    component: () => import('../pages/LoginPage.vue')
  },
  {
    path: '/login-multi-device',
    component: () => import('../pages/login-multi-device/index.vue')
  },
  {
    path: '/newContract/:reservationId?',
    component: () => import('../pages/NewContract.vue'),
  },
  {
    path: '/newContract/startNew',
    component: () => import('@/components/forms/contractFormComponents/StartNew.vue'),
  },
  {
    path: '/newBuyer',
    component: () => import('../pages/NewBuyer.vue')
  },
  {
    path: '/newBuyer/startNew',
    component: () => import('@/components/forms/buyerFormComponents/StartNew.vue')
  },
  {
    path: '/newShowing',
    component: () => import('../pages/NewShowing.vue')
  },
  {
    path: '/newShowing/sign',
    component: () => import('../pages/NewShowingSign.vue')
  },
  {
    path: '/newShowing/startNew',
    component: () => import('@/components/forms/showingFormComponents/StartNew.vue')
  },
  {
    path: '/drafts',
    component: () => import('../pages/draftsList.vue')
  },
  {
    path: '/changeIdentity',
    component: () => import('../pages/changeIdentity.vue')
  },
  {
    path: '/loginRequests',
    component: () => import('../pages/loginRequests.vue')
  },
  {
    path: '/savedContracts',
    component: () => import('../pages/SavedContracts.vue')
  },
  {
    path: '/dashboard',
    component: () => import('../pages/DashboardPage.vue')
  },
  {
    path: '/leaderboard',
    component: () => import('../pages/LeaderboardPage.vue')
  },
  {
    path: '/duoCalculator',
    component: () => import('../pages/DuoCalculatorPage.vue')
  },
  {
    path: '/systemMessages',
    component: () => import('../pages/SystemMessagesPage.vue')
  },
  {
    path: '/reservations',
    component: () => import('../pages/ReservationsPage.vue')
  },
  {
    path: '/reservations/list',
    component: () => import('../pages/ReservationsPage.vue'),
    props: { mode: 'list' }
  },
  {
    path: '/propertiesSearch/:slug?',
    component: () => import('../pages/PropertiesSearch.vue')
  },
  {
    path: '/notifications',
    component: () => import('../pages/NotificationsPage.vue')
  },
  {
    path: '/priceChange',
    component: () => import('../pages/PriceChangePage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
